<div class="flex flex-col m-8 lg:m-0 gap-10 lg:justify-center items-center h-screen">
  <h1 class="text-3xl font-bold">Placement Login</h1>
  <div [style]="formDivStyle">
    <div class="flex flex-col h-fit w-fit justify-evenly items-center">
      <img alt="Login Banner Image" class="w-[14rem] pointer-events-none" [src]="localStorage.getItem('loginLogoUrl')"/>
    </div>
    <full-button (click)="netIDLogin()" text="NetID Login" />
  </div>

  @if (errorMessage) {
    <div class="bg-red-200 text-red-800 p-3 rounded-md" >
      <p>{{ errorMessage }}</p>
    </div>
  }
  <!--<div class="flex items-center gap-4 bg-amber-50 border border-amber-300 rounded-md px-4 py-3 mt-2 mb-4 w-[50%]">
    <span class="text-amber-500 mt-0.5"><fa-icon class="ml-1" [icon]="faTriangleExclamation"/> </span>
    <p class="text-amber-800 text-sm"><b>Attention incoming students!</b><br/>To access the eLearning platform, please set up your <a class="text-blue-600 underline hover:text-blue-800" href="https://tools.rutgers.edu/manage/emails">email</a>
      and complete this <a class="text-blue-600 underline hover:text-blue-800" href="https://netid.rutgers.edu/activateNetId.htm">form</a>. After completing these steps, wait (2) days, clear your browsing history, refresh your screen (CTRL+SHIFT+R), and try logging back into eLearning.<br/><br/>
      If you’re still unable to access the platform, please let us know by <a class="text-blue-600 underline hover:text-blue-800" href="mailto:otp@echo.rutgers.edu">emailing us</a> with a screenshot of the issue along with the date and time you attempted to log in.
    </p>
  </div>-->

</div>
